<boi-form-information-box [message]="referenceDataLabels.ApplicantsDescription"></boi-form-information-box>

<ng-container *ngIf="kfiApplicants">
  <ng-container *ngFor="let applicant of kfiApplicants; let index = index; let first = first">
    <h1 class="bo-title-text vo-heading-regular-20 mt-30 my-15" *ngIf="first; else notFirst">
      {{ referenceDataLabels.ApplicantPrimaryContactId | localizeLabel }}
    </h1>

    <ng-template #notFirst>
      <div class="dots-separator"></div>
      <div class="title-bar vo-separator-line mt-30 mb-15 pt-30 pl-md-0 pl-25">
        <h1 class="title-bar-text vo-heading-regular-20 m-0 mx-md-0 mx-auto">
          {{ referenceDataLabels.ApplicantId | localizeLabel }}
          {{ index + 1 }}
        </h1>
        <button class="primary-button vo-secondary-button-1 vo-display-none" (click)="openDeleteApplicantDialog(index)">
          {{ referenceDataLabels.DeleteApplicant | localizeLabel }}
        </button>
        <button class="delete-applicant-button bo-display-none" (click)="openDeleteApplicantDialog(index)"></button>
      </div>
    </ng-template>

    <boi-form-text-input
      [labelName]="referenceDataLabels.FirstName"
      [(value)]="applicant.Forename"
      [propertyNames]="['KfiApplicant_' + index + '.Forename']"
      [isFieldDisabled]="isReadOnly"
      [fieldMaxLength]="30"
      [contextualHelpName]="referenceDataContextualHelps.KfiAboutApplicants"
      (valueChange)="updateApplicantsEvent.emit(kfiApplicants)"
    >
    </boi-form-text-input>

    <boi-form-text-input
      [labelName]="referenceDataLabels.LastName"
      [(value)]="applicant.Surname"
      [propertyNames]="['KfiApplicant_' + index + '.Surname']"
      [isFieldDisabled]="isReadOnly"
      [fieldMaxLength]="30"
      [contextualHelpName]="referenceDataContextualHelps.KfiAboutApplicants"
      (valueChange)="updateApplicantsEvent.emit(kfiApplicants)"
    >
    </boi-form-text-input>
  </ng-container>

  <div *ngIf="kfiApplicants.length < 4" class="add-applicant-container vo-display-none">
    <div class="dots-separator"></div>
    <div class="form-element add-applicant d-flex">
      <div class="form-label">{{ referenceDataLabels.AddAnotherApplicant | localizeLabel }}</div>
      <div class="form-input-container ml-30">
        <button class="primary-button vo-secondary-button-1" (click)="addApplicant()">
          + {{ referenceDataLabels.ButtonAddAnotherApplicant | localizeLabel }}
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="kfiApplicants.length < 4" class="bo-display-none d-flex flex-row-reverse flex-md-row mt-15">
    <button class="vo-secondary-button-1 vo-add-applicant-button" (click)="addApplicant()">
      {{ referenceDataLabels.AddAnotherApplicant | localizeLabel }}
    </button>
  </div>

  <div class="dots-separator"></div>
</ng-container>

<boi-delete-kfi-applicant-dialog
  class="vo-modal vo-modal--standard"
  [(opened)]="isDeleteApplicantDialogOpen"
  [data]="selectedApplicantIndex"
  (confirmAction)="deleteApplicant($event)"
>
</boi-delete-kfi-applicant-dialog>
